export default {
  init() {

  },
  finalize() {

    // edit these vars
    var nice_url   = true;
    var pagination = false;
    var animation_speed = '0';
    var post_order = 'DESC';
    var random_posts = false;
    var featured_image = true;
    var acf = true;

    // default vars
    var page      = 0;
    var filter    = 0;
    var numberposts = 9;
    var total_item_count = 0;
    var exlude_ids = [];
    var seed = Math.floor(Math.random() * 1000) + 1;

    // loop the filter buttons and check if selected filter is set
    $('.lazy-load-filter').each(function() {
      // if finds selected index set the filter id
      if($(this).data('selected')) {
        filter = $(this).data('index');
      }
    })

    // load initail items
    getLazyItems();

    // assign buttons to clicks
    $('.lazy-load-more').click(() => getLazyItems());
    $('.lazy-load-filter').click((e) => setLazyFilter(e));
    $('.lazy-load-filter-mobile').change((e) => setLazyFilter(e, true));

    function setLazyFilter(e, mobile = false) {
      var target = $(e.target);

      if(mobile) {
        target = $(e.target).find(':selected');
      }

      // clear current items from div
      exlude_ids = [];

      $('.lazy-load-items').fadeOut(animation_speed, function() {

        // Animation complete.
        $('.lazy-load-items').empty();
        // reset page to 0
        page = 0;

        // set the filter id from the data index
        filter = target.data('index');

        // get the items with the new filter id
        getLazyItems()

        $('.lazy-load-filter').each(function() {
          $(this).removeClass('active');
        })

        target.addClass('active');

        $('.lazy-load-items').fadeIn( animation_speed);
        //set pretty slug url
        if(nice_url) {
          window.history.pushState('', '', target.data('slug'));
        }
      });
    }

    function getLazyItems() {
      console.log('lazy');
      // hide load more button to counter flickering
      $('.lazy-load-pagination').hide();

      // eslint-disable-next-line no-undef
      var ajax_url = ajax_object.ajax_url;

      // set initial post count
      total_item_count = 5;

      var tax_query = '';

      if(filter != 0) {
        tax_query = [{
          'taxonomy': 'news-categories',
          'field': 'slug',
          'terms': filter,
        }];
      }

      // do ajax(super joden) call to the server
      $.ajax({
        type: 'post',
        url: ajax_url,
        data : {
          action: 'lazyload', // action called in ajax.php
          featured_image: featured_image,
          acf: acf,
          args: { // args parameters passed to wp_query method
            'posts_per_page': numberposts,
            'post_type': 'news',
            'post_status':'publish',
            'paged': page + 1,
            'tax_query': tax_query,
            'order': post_order,
            'orderby': random_posts ? 'RAND(' + seed + ')' : 'ID',
          },
        },
      }).done(function(items) {

        //
        $('.lazy-load-pagination').show();

        // set items string to array
        var responseItems = JSON.parse(items);

        // set global total var
        total_item_count = responseItems.total_item_count;

        // check if items available
        if(responseItems.items.length > 0 ) {

          var item_html = '';

          // loop the items
          responseItems.items.map((element) => {

            if(random_posts) {
              if(exlude_ids.includes(element.ID) === false) {
                exlude_ids.push(element.ID);
              }
            }

            // eslint-disable-next-line no-undef
            // var asset_path = path_object.assets_path;

            // style the items and append them to the frontend div

            item_html += `
                  <div class="w-full px-4 md:px-0 flex flex-col overflow-hidden relative flex-0">
                    <a href="${element.permalink}" class="block absolute inset-0 z-1"></a>
                    <div class="flex-shrink-0 relative">
                        <div class="absolute left-8 top-8 md:left-10 md:top-10 inline-block px-2 md:px-3 mx-2 md:mx-3 py-1 md:py-2 font-primary text-xs md:text-sm font-light bg-green text-black duration-300 transition-all ease-in-out z-2">
                          <div class="absolute -left-2 transform -skew-x-12 top-0 bottom-0 w-4 text-black bg-green"></div>
                          ${element.news_categories}
                          <div class="absolute -right-2 transform -skew-x-12 top-0 bottom-0 w-4 text-black bg-green"></div>
                        </div>
                        <div class="h-48 w-full object-cover relative overflow-hidden">
                          ${element.featured_image}
                        </div>
                    </div>
                    <div class="flex-1 bg-white p-8 md:p-10 flex flex-col justify-between">
                      <div class="flex-1">
                          <h3 class="mt-2 font-semibold leading-tight font-sans text-gray-900 truncate-3-lines">
                            ${element.post_title}
                          </h3>
                          <p class="mt-4 truncate-3-lines text-black">
                            ${element.excerpt}
                          </p>
                      </div>
                      <div class="mt-6 flex items-center">
                        <div class="flex text-sm leading-5 text-gray-300">
                          <span>
                            <svg class="h-4 w-4 inline-block mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 18">
                              <path fill="#B3B3B3" fill-rule="evenodd" d="M7.81178947,2.26088421 C12.1191579,2.26088421 15.624,5.71351579 15.624,9.95730526 C15.624,14.2015158 12.1191579,17.6541474 7.81178947,17.6541474 C3.50442105,17.6541474 -1.02140518e-13,14.2015158 -1.02140518e-13,9.95730526 C-1.02140518e-13,5.71351579 3.50442105,2.26088421 7.81178947,2.26088421 Z M7.81178947,3.52404211 C4.19494737,3.52404211 1.26315789,6.40446316 1.26315789,9.95730526 C1.26315789,13.5105684 4.19494737,16.3909895 7.81178947,16.3909895 C11.4286316,16.3909895 14.3608421,13.5105684 14.3608421,9.95730526 C14.3608421,6.40446316 11.4286316,3.52404211 7.81178947,3.52404211 Z M7.74698947,5.38277895 C8.09604211,5.38277895 8.37856842,5.66572632 8.37856842,6.01435789 L8.37856842,6.01435789 L8.37856842,9.80383158 L12.2472,9.80383158 C12.5958316,9.80383158 12.8787789,10.0867789 12.8787789,10.4354105 C12.8787789,10.7840421 12.5958316,11.0669895 12.2472,11.0669895 L12.2472,11.0669895 L7.74698947,11.0669895 C7.39835789,11.0669895 7.11541053,10.7840421 7.11541053,10.4354105 L7.11541053,10.4354105 L7.11541053,6.01435789 C7.11541053,5.66572632 7.39835789,5.38277895 7.74698947,5.38277895 Z M4.97284211,0.452210526 C6.74378947,-0.133473684 8.71010526,-0.150736842 10.4877895,0.404210526 C10.8208421,0.507789474 11.0065263,0.862315789 10.9025263,1.19494737 C10.7989474,1.528 10.4461053,1.71494737 10.1117895,1.60968421 C8.58463158,1.13305263 6.89157895,1.14736842 5.37031579,1.65136842 C5.30421053,1.67326316 5.23726316,1.68336842 5.17157895,1.68336842 C4.90631579,1.68336842 4.66,1.51578947 4.572,1.25052632 C4.46210526,0.919578947 4.64189474,0.562105263 4.97284211,0.452210526 Z"/>
                            </svg>
                            ${element.readingtime} min. leestijd
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>`;
          });

          $('.lazy-load-items').fadeIn(animation_speed, function() {});

          if(pagination) {
            $('.lazy-load-items').html(item_html);
          } else {
            $('.lazy-load-items').append(item_html);
          }

        } else {
          // no items available
          if(!pagination) {
            $('.lazy-load-loaded').append('<div class="end-lazyload text-center text-sm opacity-50 w-full mt-2">Alle items zijn ingeladen</div>');
          }
        }

      }).then(function(){
        renderPagination()
      });
    }

    function nextPage(){page = page + 1;}
    function prevPage(){page = page - 1;}
    function setPage(pageNumber){page = pageNumber;}

    function renderPagination() {
      var total_render_pages = Math.ceil(total_item_count / numberposts);

      var pagination_render = '';

      if(pagination) {

        for (var i = 0; i < total_render_pages; i++) {
          pagination_render += '<button class="lazy-load-set-page" data-page="'+i+'">'+(i + 1) +'</button>';
        }

      } else {
        if(total_render_pages >= 1 ) {
          pagination_render +='<button class="lazy-load-more button focus:outline-none">Meer laden</button>';
        }
      }

      $('.lazy-load-pagination').html(pagination_render);
    }

    $('.lazy-load-pagination').on('click', '.lazy-load-more', function() {
        nextPage();
        getLazyItems();
    });

    $('.lazy-load-pagination').on('click', '.lazy-load-prev', function() {
        prevPage()
        getLazyItems();
    });

    $('.lazy-load-pagination').on('click', '.lazy-load-next', function() {
        nextPage();
        getLazyItems();
    });
    $('.lazy-load-pagination').on('click', '.lazy-load-set-page', function() {
        setPage($(this).data('page'));
        getLazyItems();

    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/news.js